import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import vPosterImg from '../assets/images/v-poster.png';
import { candidateExplainerData as data } from '../data/candidate-explainer.data';
import { useRedirectUrl } from '../hooks/useRedirectUrl';
import styles from "./candidate-explainer.module.scss";
import "./candidate-explainer.scss";

export function CandidateExplainer() {
  const redirect = useRedirectUrl();

  return (
    <div className={`${styles["candidateExplainer"]} candidate-container`}>
      <Helmet>
        <title>Sapia | Candidate Explainer</title>
        <meta http-equiv="refresh" content="0; url=https://sapia.ai/candidate-explainer/" />
      </Helmet>
      {/* <div className={styles["explainerBanner"]}>
        <ul className={styles["landingBreadcrumbs"]}>
          {data?.header_section?.breadcrums.map((b, i) => {
            switch (i) {
              case 0:
                return (
                  <li className={styles["candidateBtn"]} key={i}>
                    <a href={redirect}>{b.label}</a>
                  </li>
                )
              default:
                return b.link ? (
                  <li key={i}>
                    <Link to={b.link}>{b.label}</Link>
                  </li>) : (<span>{b.label}</span>
                )
            }
          })}
        </ul>

        <div className={styles["explainerBannerText"]}>
          <h1>
            {data?.header_section?.page_title}&nbsp;
            <span>{data?.header_section?.page_title_highlighted}</span>
          </h1>
        </div>
      </div>

      {data?.header_section?.video_url && (
        <div className={styles.explainerVideo}>
          <video src={data?.header_section?.video_url} controls poster={vPosterImg}></video>
          <div
            className={`${styles["candidateBtn"]} ${styles["candidateBtn_Red"]}`}
          >
            <a href={redirect}>
              {data.header_section.back_link_label}
            </a>
          </div>
        </div>
      )}

      {data?.main_section?.map((s, i) => {
        switch (s.section_type) {
          case "1":
            return (
              <div className="first-interview" key={i}>
                <div className="container">
                  <div className="explainer-seprator">
                    <div className="section-type1">
                      <div className="section-type1_text"
                        dangerouslySetInnerHTML={{ __html: s.section_content }}
                      />
                      {s.section_image && typeof s.section_image === 'string' &&
                        <div className="section-type1_img">
                          <img src={s.section_image as string} alt="" />
                        </div>}
                    </div>
                  </div>
                </div>
              </div>
            )
          case "4":
            return (
              <div className="this-page-section" key={i}>
                <div className="container">
                  <div
                    dangerouslySetInnerHTML={{ __html: s.section_content }}
                  />
                </div>
              </div>
            )
        }
      })}

      <div className="interview-support-section explainer-padding">
        <div className="container">
          <div className="text-center">
            <h3 className="blue-title">
              {data.contact_section.section_title}
            </h3>
            <button type="button" className="btn-help" style={{cursor: 'pointer'}}>
              {data.contact_section.button_label}
            </button>
            <p>
              <a
                href={data.contact_section.privacy_button_link}
                className="black-link"
              >
                {data.contact_section.privacy_button_label}
              </a>
            </p>
            <p>
              <a
                href="/terms-of-service"
                className="black-link"
              >
                Read our Terms of Service here >
              </a>
            </p>
          </div>
        </div>
      </div> */}
    </div>
  );
}


